import { render } from "./ParagraphCard.vue?vue&type=template&id=1db25b54&scoped=true&ts=true"
import script from "./ParagraphCard.vue?vue&type=script&lang=ts"
export * from "./ParagraphCard.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db25b54"]])

export default __exports__